'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _GA = require('components/GA');

var _GA2 = _interopRequireDefault(_GA);

var _ReactUpdates = require('react-dom/lib/ReactUpdates');

var _ReactUpdates2 = _interopRequireDefault(_ReactUpdates);

var _ReactDefaultBatchingStrategy = require('react-dom/lib/ReactDefaultBatchingStrategy');

var _ReactDefaultBatchingStrategy2 = _interopRequireDefault(_ReactDefaultBatchingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isHandlingError = false;

var Log = (_temp = _class = function () {
  function Log() {
    var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __DEVELOPMENT__ ? this.LEVEL_DEBUG : this.LEVEL_INFO;
    (0, _classCallCheck3.default)(this, Log);

    this._level = level;
    this.onErrorHandler();
  }

  (0, _createClass3.default)(Log, [{
    key: 'onErrorHandler',
    value: function onErrorHandler() {
      var _this = this;

      var self = this;

      var ReactTryCatchBatchingStrategy = {
        // this is part of the BatchingStrategy API. simply pass along
        // what the default batching strategy would do.
        get isBatchingUpdates() {
          return _ReactDefaultBatchingStrategy2.default.isBatchingUpdates;
        },

        batchedUpdates: function batchedUpdates() {
          try {
            _ReactDefaultBatchingStrategy2.default.batchedUpdates.apply(_ReactDefaultBatchingStrategy2.default, arguments);
          } catch (err) {
            if (isHandlingError) {
              // our error handling code threw an error. just throw now
              throw err;
            }

            isHandlingError = true;
            try {
              var _ref = err || {},
                  message = _ref.message,
                  stack = _ref.stack;

              self.e({ message: message, stack: stack });
            } finally {
              isHandlingError = false;
            }
          }
        }
      };
      _ReactUpdates2.default.injection.injectBatchingStrategy(ReactTryCatchBatchingStrategy);

      if (typeof window !== 'undefined') {
        var oldOnError = window.onerror || _noop3.default;
        window.onerror = function (msg, url, line, column, error) {
          oldOnError(msg, url, line, column, error);
          var stack = (0, _get3.default)(error, 'stack');
          _this.e({ msg: msg, url: url, line: line, column: column || (0, _get3.default)(window, 'event.errorCharacter'), stack: stack });
          return false;
        };
      }
    }
  }, {
    key: 'level',
    value: function level(_level) {
      if (typeof _level !== 'undefined') {
        this._level = _level;
      }
      return this._level;
    }
  }, {
    key: 'getLogArgs',
    value: function getLogArgs(args) {
      if (args.length > 1) {
        var tag = args.shift(0);
        return ['[' + tag + ']'].concat((0, _toConsumableArray3.default)(args));
      }
      return args;
    }
  }, {
    key: 'd',
    value: function d() {
      var _console;

      // eslint-disable-line id-length
      if (this._level > this.LEVEL_DEBUG) {
        return this;
      }

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_console = console).log.apply(_console, (0, _toConsumableArray3.default)(this.getLogArgs(args)));
      return this;
    }
  }, {
    key: 'i',
    value: function i() {
      var _console2;

      // eslint-disable-line id-length
      if (this._level > this.LEVEL_INFO) {
        return this;
      }

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      (_console2 = console)[console.info ? 'info' : 'log'].apply(_console2, (0, _toConsumableArray3.default)(this.getLogArgs(args)));
      return this;
    }
  }, {
    key: 'w',
    value: function w() {
      var _console3;

      // eslint-disable-line id-length
      if (this._level > this.LEVEL_WARNING) {
        return this;
      }

      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      (_console3 = console).warn.apply(_console3, (0, _toConsumableArray3.default)(this.getLogArgs(args)));
      return this;
    }
  }, {
    key: 'e',
    value: function e() {
      var _console4;

      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      // eslint-disable-line id-length
      if (this._level > this.LEVEL_ERROR) {
        return this;
      }
      (_console4 = console).error.apply(_console4, (0, _toConsumableArray3.default)(this.getLogArgs(args)));
      if (!__DEVELOPMENT__) {
        _GA2.default.exception({ description: args, fatal: true });
      }
      return this;
    }
  }, {
    key: 'debug',
    value: function debug() {
      return this.d.apply(this, arguments);
    }
  }, {
    key: 'info',
    value: function info() {
      return this.i.apply(this, arguments);
    }
  }, {
    key: 'warning',
    value: function warning() {
      return this.w.apply(this, arguments);
    }
  }, {
    key: 'error',
    value: function error() {
      return this.e.apply(this, arguments);
    }
  }]);
  return Log;
}(), _class.LEVEL_DEBUG = 0, _class.LEVEL_INFO = 1, _class.LEVEL_WARNING = 2, _class.LEVEL_ERROR = 3, _temp);
exports.default = new Log();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/log.js
// module id = 267
// module chunks = 1